import { render, staticRenderFns } from "./SearchHolder.vue?vue&type=template&id=7c2fc22d&scoped=true&"
import script from "./SearchHolder.vue?vue&type=script&lang=js&"
export * from "./SearchHolder.vue?vue&type=script&lang=js&"
import style0 from "./SearchHolder.vue?vue&type=style&index=0&id=7c2fc22d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fc22d",
  null
  
)

export default component.exports